<template>
  <div>
    <PageWrapper :items="navItems" :fields="infoFields">
      <template v-slot:content>
        <div>
          <PracticeViewContent
            :showTestView="showTestView"
            :timer="timer"
            :navigator="navItems"
            :currentRecordProperties="infoFields"
            ref="practiceViewContent"
          />
        </div>
      </template>
      <template v-slot:other-buttons>
        <div>
          <b-button
            v-if="currentWord.picture !== null && currentWord.picture.length > 0"
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="togglePicture"
          >{{ $t('Vocabulary.seePicture') }}</b-button>
          <b-button
            v-if="currentWord.video !== null && currentWord.video.length > 0"
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="toggleVideo"
          >{{ $t('Vocabulary.playVideo') }}</b-button>
          <b-button
            v-if="currentWord.external_source !== null && currentWord.external_source.length > 0"
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="toggleExternalSource"
          >{{ $t('Vocabulary.externalSource') }}</b-button>
          <b-button
            class="custom-button end-button"
            @click="showAskLeaveModal"
          >{{ $t('Common.endAndLeave') }}</b-button>
        </div>
      </template>
    </PageWrapper>
    <div v-if="toShowPicture || toPlayVideo" class="media-modal">
      <b-icon icon="x" font-scale="2" @click="closeMediaModal"></b-icon>
      <b-img
        v-if="toShowPicture && currentWord.picture !== null && currentWord.picture.length > 0"
        v-bind="imageProps"
        :src="currentWord.picture !== null ? currentWord.picture : '#'"
      />
      <b-embed
        v-if="toPlayVideo && currentWord.video !== null && currentWord.video.length > 0"
        id="video-player"
        type="video"
        aspect="4by3"
        :src="currentWord.video"
        style="margin-top:-50px;"
        controls
        controlslist="nodownload"
        allowfullscreen
        autoplay
        oncontextmenu="return false;"
        crossorigin="anonymous"
      />
    </div>
    <RemindModal :modalName="'askLeaveModal'" :modalHeight="'150px'" ref="askLeaveModal">
      <template v-slot:header>
        <span>{{ askLeaveModalHeader }}</span>
      </template>
      <template v-slot:body>
        <p>{{ askLeaveModalBody }}</p>
      </template>
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="5" sm="6">
            <b-button class="custom-button five" @click="endAndLeave">{{$t('Common.yes')}}</b-button>
          </b-col>
          <b-col md="5" sm="6">
            <b-button class="custom-button four" @click="closeAskLeaveModal">{{$t('Common.cancel')}}</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </RemindModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageWrapper from '../../PageWrapper/PageWrapper'
import PracticeViewContent from './PracticeViewContent'
import RemindModal from '../../CustomModal/RemindModal.vue'
import Timer from '../../../util/Timer'
import { secondToHMS } from '../../../util/time'
import { roundDecimal } from '../../../util/math'
import { PRACTICEMODE } from '../vocabularyMode'

export default {
  name: 'PracticeView',
  props: {
    showTestView: {
      type: Function,
      required: true
    }
  },
  components: {
    PageWrapper,
    PracticeViewContent,
    RemindModal
  },
  watch: {
    currentWord (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.toPlayVideo = false
        this.toShowPicture = false
      }
    }
  },
  data () {
    return {
      timer: new Timer(),
      toShowPicture: false,
      toPlayVideo: false,
      imageProps: {
        center: true,
        width: 'auto',
        height: '300px'
      },
      askLeaveModalHeader: '',
      askLeaveModalBody: ''
    }
  },
  computed: {
    ...mapState({
      currentRule: (state) => state.vocabularyPractice.currentRule,
      currentWord: (state) => state.vocabularyPractice.currentWord,
      currentWordIndex: (state) => state.vocabularyPractice.currentWordIndex,
      correctCount: (state) => state.vocabularyPractice.correctCount,
      incorrectCount: (state) => state.vocabularyPractice.incorrectCount,
      practiceJudgeResult: state => state.vocabularyPractice.practiceJudgeResult,
      practiceWordListLength: state => state.vocabularyPractice.practiceWordListLength,
      mode: (state) => state.vocabularyPractice.mode,
      practiceMode: (state) => state.vocabularyPractice.practiceMode
    }),
    totalCount () { // 當前單字的总次数
      return this.practiceJudgeResult[this.currentWordIndex].correctCount + this.practiceJudgeResult[this.currentWordIndex].incorrectCount
    },
    correctRate () { // 當前單字的正確率
      if (this.totalCount > 0) {
        return roundDecimal((this.practiceJudgeResult[this.currentWordIndex].correctCount / this.totalCount) * 100, 2)
      }
      return 0
    },
    navItems () {
      let modeLabel = this.mode
      switch (this.mode) {
        case 'LEARNNEW': modeLabel = this.$t('Vocabulary.learnNew')
          break
        case 'REVIEW': modeLabel = this.$t('Vocabulary.review')
          break
        case 'FORCEREVIEW': modeLabel = this.$t('Vocabulary.forceReview')
          break
        case 'EXAMSIMULATION': modeLabel = this.$t('Vocabulary.examSimulation')
          break
        case 'EXAM': modeLabel = this.$t('Vocabulary.exam')
          break
      }
      return [
        {
          label: '字汇',
          link: 'vocabulary'
        },
        {
          label: modeLabel
        },
        {
          label: '一般学习'
        }
      ]
    },
    infoFields () {
      return [
        {
          label: this.$t('Vocabulary.numberOfQuestions'),
          value: `第 ${this.currentWordIndex + 1} / ${
            this.practiceWordListLength
          } 题`
        },
        {
          label: this.$t('Vocabulary.practiceCount'),
          value: this.practiceMode === PRACTICEMODE.NORMAL ? `${this.totalCount}` : `（无）`
        },
        {
          label: this.$t('Vocabulary.incorrectCount'),
          value: this.practiceMode === PRACTICEMODE.NORMAL ? `${this.practiceJudgeResult[this.currentWordIndex].incorrectCount}` : `（无）`
        },
        {
          label: this.$t('Vocabulary.correctCount'),
          value: this.practiceMode === PRACTICEMODE.NORMAL ? `${this.practiceJudgeResult[this.currentWordIndex].correctCount}` : `（无）`
        },
        {
          label: this.$t('Vocabulary.correctRate'),
          value: this.practiceMode === PRACTICEMODE.NORMAL ? `${this.correctRate}%` : `（无）`
        },
        {
          label: this.$t('Vocabulary.usedTime'),
          value: `${secondToHMS(this.timeElapsed)}`
        }
      ]
    },
    timeElapsed () {
      if (this.timer.timeElapsed) {
        return this.timer.timeElapsed / 1000
      }
      return 0
    }
  },
  methods: {
    togglePicture () {
      console.log('togglePicture', this.currentWord.picture)
      if (this.toPlayVideo || document.querySelector('#video-player')) {
        document.querySelector('#video-player').pause()
      }
      this.toPlayVideo = false
      this.toShowPicture = true
    },
    toggleVideo () {
      this.toShowPicture = false
      this.toPlayVideo = true
    },
    toggleExternalSource () {
      window.open(this.currentWord.external_source, '_blank').focus()
    },
    closeMediaModal () {
      this.toShowPicture = false
      this.toPlayVideo = false
    },
    // endPractice () {
    //   this.timer.stopTimer()
    //   this.$store.commit('vocabularyPractice/setLeave', true)
    //   this.$refs.practiceViewContent.uploadResult()
    // }
    showAskLeaveModal () {
      this.askLeaveModalHeader = this.$t('Common.notice')
      this.askLeaveModalBody = this.$t('Common.askLeave')
      this.timer.stopTimer()
      this.$refs.askLeaveModal.showModal()
      this.askLeaveModalIsHidden = false
    },
    endAndLeave () {
      this.timer.stopTimer()
      this.$store.commit('vocabularyPractice/resetAll')
      this.$store.commit('vocabularyPractice/setLeave', true)
      this.$refs.askLeaveModal.closeModal()
      this.$router.replace('/vocabulary')
    },
    closeAskLeaveModal () {
      this.$refs.askLeaveModal.closeModal()
      this.timer.startTimer()
    }
  }
}
</script>

<style lang='scss' scoped>
.media-modal {
  width: 400px;
  height: 300px;
  position: fixed;
  bottom: 0;
  right: 0;
  text-align: right;
  z-index: 0;
}
</style>
